<div class="page-container">
    <div class="page-title-block">
        <div class="page-type">Input Page</div>
        <div class="more-info-btn" (click)="openMoreInfo()">More info</div>
    </div>
    <ng-container *ngTemplateOutlet="inputPageFormTemplate"></ng-container>
    <div class="more-info-container" [ngClass]="{ 'open': moreInfoOpened }">
        <div class="close-btn-block">
            <button class="close-btn" (click)="closeMoreInfo()">Close</button>
        </div>
        <div class="title">Input Page</div>
        <img src="../../../../../../../../../../assets/img/ABF_more_info/inputPage.jpg" alt="More info">
        <div class="desc">A input page allows a user to enter any kind of input which could be numerical, alphabetic, alphanumeric, etc.</div>
        <div class="desc eg">E.G. entering a first name</div>
    </div>
</div>

<ng-template #inputPageFormTemplate>
    <div class="page-content">
        <ng-container [formGroup]="inputPageForm">
            <div class="fields-block">
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Page Header</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field" placeholder="Enter page header" [formControlName]="'pageHeader'" (ngModelChange)="setPageDataHandler()"/>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Page Subheader</label>
                    </div>
                    <input class="input-field" placeholder="Enter subheader" [formControlName]="'pageSubHeader'"/>
                    <input-validators controlName="pageSubHeader" [control]="inputPageForm.controls['pageSubHeader']"></input-validators>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Regular Expression</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field" placeholder="Enter a regular expression" [formControlName]="'regex'"/>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Placeholder Text</label>
                    </div>
                    <input class="input-field" placeholder="Enter a placeholder text" [formControlName]="'placeHolder'"/>
                    <input-validators controlName="pageSubHeader" [control]="inputPageForm.controls['placeHolder']"></input-validators>
                </div>
                <span class="line"></span>
                <div class="form-field-block full-size">
                    <div class="label-container">
                        <label class="label">Input Type</label>
                    </div>
                    <div class="input-type-block">
                        <label class="label bordered">
                            <input class="checkbox" type="radio" value="singleline" name="inputType" [formControlName]="'inputType'" checked/>
                            <span class="checkbox-styled"></span>
                            <span class="label-text">Single line</span>
                        </label>
                        <label class="label bordered">
                            <input class="checkbox" type="radio" value="multiline" name="inputType" [formControlName]="'inputType'"/>
                            <span class="checkbox-styled"></span>
                            <span class="label-text">Multi line</span>
                        </label>
                    </div>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Label Text</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field" placeholder="Enter a label text" [formControlName]="'labelText'"/>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Prefix Text</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field" placeholder="Enter a prefix text" [formControlName]="'prefixText'"/>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Max Character Count</label>
                        <label class="optional">Optional</label>
                    </div>
                    <input class="input-field" placeholder="Enter a character count (Max 300)" [formControlName]="'maximumCharacterCount'"/>
                    <input-validators controlName="maximumCharacterCount" [control]="inputPageForm.controls['maximumCharacterCount']"></input-validators>
                </div>
                <div class="form-field-block">
                    <div class="label-container">
                        <label class="label">Keyboard Type</label>
                    </div>
                    <div class="select-block">
                        <mat-select class="dynamic-dropdown" [formControlName]="'keyboardType'">
                            <mat-option [value]="'default'">Default</mat-option>
                            <mat-option [value]="'asciiCapable'">Ascii</mat-option>
                            <mat-option [value]="'numbersAndPunctuation'">Numbers and Punctuations</mat-option>
                            <mat-option [value]="'URL'">URL</mat-option>
                            <mat-option [value]="'numberPad'">Number Pad</mat-option>
                            <mat-option [value]="'phonePad'">Phone Pad</mat-option>
                            <mat-option [value]="'namePhonePad'">Name Phone Pad</mat-option>
                            <mat-option [value]="'emailAddress'">Email Address</mat-option>
                            <mat-option [value]="'decimalPad'">Decimal Pad</mat-option>
                            <mat-option [value]="'UIKeyboardTypeTwitter'">UI Keyboard Type Twitter</mat-option>
                            <mat-option [value]="'webSearch'">Web Search</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div class="toggle-field">
                    <div class="label-left-block">
                        <label class="label">Make it required</label>
                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'required'"></app-cms>
                    </div>
                    <div class="toggle-btn">
                        <mat-slide-toggle [color]="'primary'" class="control-toggle" [formControlName]="'required'">
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>
